import { ChangeDetectorRef, Component, inject, input } from '@angular/core';
import { chevronLeftIcon, chevronRightIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'app-planner-control-bar',
  templateUrl: './planner-control-bar.component.html',
  styleUrl: './planner-control-bar.component.scss',
  standalone: false,
})
export class PlannerControlBarComponent {
  startOfMonth = input.required<Date>();
  prev = input.required<(cd: ChangeDetectorRef) => void>();
  today = input.required<(cd: ChangeDetectorRef) => void>();
  next = input.required<(cd: ChangeDetectorRef) => void>();

  public readonly cd = inject(ChangeDetectorRef);

  // Constants
  public readonly chevronLeftIcon = chevronLeftIcon;
  public readonly chevronRightIcon = chevronRightIcon;
}
